<template>
<div>
    <Header title="课程介绍" />
    <van-tabs color="#7181EB" title-active-color="#7181EB" v-model="active">
        <van-tab title="课程报名">
            <div class="scrollerView" :style="{ height: (wrapperHeight- 105) + 'px' }">
                <scroller
                    :on-refresh="refresh"
                    :on-infinite="infinite"
                    :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                    ref="infinite"
                    class="scroller"
                >
                    <courseItem v-for="(item, index) in dataSources" :key="index" :item="item" :type="1" />
                    <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
                </scroller>
            </div>
        </van-tab>
        <van-tab title="课程介绍">
            <div class="scrollerView" :style="{ height: (wrapperHeight- 105) + 'px' }">
                <scroller
                    :on-refresh="refresh_A"
                    :on-infinite="infinite_A"
                    :noDataText="dataSource2.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                    ref="infinite_A"
                    class="scroller"
                >
                    <courseItem v-for="(item, index) in dataSource2" :key="index" :item="item" :type="2" />
                    <van-empty description="暂无信息～" v-if="dataSource2.length < 1 && !loading" />
                </scroller>
            </div>
        </van-tab>
    </van-tabs>
    <Footer :idx="1" />
</div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import CourseItem from '@/components/item/courseItem'
export default {
    /** 组件挂载 */
    components: {
        Header,
        Footer,
        CourseItem,
    },
    /** 数据区 */
    data() {
        return {
            loading: false,
            active: 0,
            wrapperHeight: 0, //屏幕高度 - 脚部
            // 列表
            page: 0,
            limit: 10,
            dataSources: [],
            no_more: false,
            no_data: false,
            // 列表A
            page_A: 0,
            limit_A: 10,
            dataSource2: [],
            no_more_A: false,
            no_data_A: false,
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    /** 方法 */
    methods: {
        // 列表
        refresh() {
            this.page = 1;
            this.requestData();
        },
        infinite() {
            this.page++
            this.requestData();
        },
        // 请求首页数据
        async requestData() {
            let url = this.API.course_enroll_list;
            let params = {
                page: this.page,
                limit: this.limit
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let list = result.data.data
                if (this.page === 1) {
                    this.dataSources = list
                } else {
                    this.dataSources = this.dataSources.concat(list)
                }
                this._onStopLoading(list.length < this.limit);
            } else {
                this.Message({title: result.msg});
                this._onStopLoading(true);
            }
        },
        // 列表 A
        refresh_A() {
            this.page_A = 1;
            this.requestData_A();
        },
        infinite_A() {
            this.page_A++
            this.requestData_A();
        },
        // 请求首页数据
        async requestData_A() {
            let url = this.API.course_introduce_list;
            let params = {
                page: this.page_A,
                limit: this.limit_A
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let list = result.data
                if (this.page_A === 1) {
                    this.dataSource2 = list
                } else {
                    this.dataSource2 = this.dataSource2.concat(list)
                }
                this._onStopLoading(list.length < this.limit_A);
            } else {
                this.Message({title: result.msg});
                this._onStopLoading(true);
            }
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log('status---->', status, this.$refs.infinite.finishInfinite(true));
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite && this.$refs.infinite.finishInfinite(status);

                this.$refs && this.$refs.infinite_A && this.$refs.infinite_A.finishPullToRefresh();
                this.$refs && this.$refs.infinite_A && this.$refs.infinite_A.finishInfinite(status);
            }, 500);
        },
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}
</style>
